import { render, staticRenderFns } from "./SettingsAddressBookView.vue?vue&type=template&id=09b4795a&scoped=true&"
import script from "./SettingsAddressBookView.vue?vue&type=script&lang=js&"
export * from "./SettingsAddressBookView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAddressBookView.vue?vue&type=style&index=0&id=09b4795a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4795a",
  null
  
)

export default component.exports